export default __webpack_public_path__ + "static/FenixMind-9c3523bcb140b39040cdc5409baf33b8.webp";